__turbopack_context__.v({
  "ancillary": "MegaMenu-module-scss-module__TBEPqa__ancillary",
  "ancillary-link": "MegaMenu-module-scss-module__TBEPqa__ancillary-link",
  "backdrop": "MegaMenu-module-scss-module__TBEPqa__backdrop",
  "content": "MegaMenu-module-scss-module__TBEPqa__content",
  "facebook": "MegaMenu-module-scss-module__TBEPqa__facebook",
  "fade-in": "MegaMenu-module-scss-module__TBEPqa__fade-in",
  "fade-out": "MegaMenu-module-scss-module__TBEPqa__fade-out",
  "grid": "MegaMenu-module-scss-module__TBEPqa__grid",
  "instagram": "MegaMenu-module-scss-module__TBEPqa__instagram",
  "left": "MegaMenu-module-scss-module__TBEPqa__left",
  "linkedin": "MegaMenu-module-scss-module__TBEPqa__linkedin",
  "menu-close-icon": "MegaMenu-module-scss-module__TBEPqa__menu-close-icon",
  "menu-icon": "MegaMenu-module-scss-module__TBEPqa__menu-icon",
  "menu-open-icon": "MegaMenu-module-scss-module__TBEPqa__menu-open-icon",
  "positioner": "MegaMenu-module-scss-module__TBEPqa__positioner",
  "primary": "MegaMenu-module-scss-module__TBEPqa__primary",
  "primary-link": "MegaMenu-module-scss-module__TBEPqa__primary-link",
  "right": "MegaMenu-module-scss-module__TBEPqa__right",
  "social-label": "MegaMenu-module-scss-module__TBEPqa__social-label",
  "social-link": "MegaMenu-module-scss-module__TBEPqa__social-link",
  "social-links": "MegaMenu-module-scss-module__TBEPqa__social-links",
  "social-media": "MegaMenu-module-scss-module__TBEPqa__social-media",
  "trigger": "MegaMenu-module-scss-module__TBEPqa__trigger",
  "x": "MegaMenu-module-scss-module__TBEPqa__x",
  "youtube": "MegaMenu-module-scss-module__TBEPqa__youtube",
});
